
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.state-black{
  /* font-weight: bold; */
  color: rgb(110, 109, 109);
}
.state-green{
  /* font-weight: bold; */
  color: #4fa1a4;
}
.state-orange{
  /* font-weight: bold; */
  color: orange;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.management{
  padding: 0 50px;
}
.list-textarea{
  flex: 1;
}
.management-list{
  display: flex;
  /* margin-bottom: 15px; */
}
.select-department{
  color: green;
  text-decoration: underline;
  cursor: pointer;
}
.management-name{
  flex-shrink: 0;
}
.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">发起人：</div>
          <el-input v-model="page.staffName" class="ipt-sty" placeholder="请输入"></el-input
        ></el-col>

        <el-col :span="8">
          <div class="search-area-div">会议状态：</div>
          <el-select v-model="page.meetingStartState" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in meetingStartState" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div w110">会议开始时间：</div>
          <el-date-picker
            class="w68f"
            v-model="page.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
            </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15">
        <el-col :span="8"
          ><div class="search-area-div">会议主题：</div>
          <el-input v-model="page.meetingSubject" class="ipt-sty" placeholder="请输入"></el-input
        ></el-col>
        <el-col :span="16" class="t-right">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff p16 mt15">
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="所属公司"
          header-align="center"
          min-width="240"
          align="left"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="staffName"
          label="发起人"
          header-align="center"
          width="90"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="organisationName"
          label="所在部门"
          header-align="center"
          width="140"
          align="left"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="meetingSubject"
          label="会议主题"
          header-align="center"
          min-width="180"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="meetingTimeLong"
          label="会议时长"
          header-align="center"
          align="left"
          width="100"
        > <template slot-scope="scope">{{ scope.row.meetingTimeLong ? scope.row.meetingTimeLong+'分钟':'-'}}</template></el-table-column>
        <el-table-column prop="meetingState" label="会议状态" header-align="center" align="left" width="90">
            <template slot-scope="scope"><span class="state-black" v-if="scope.row.meetingState == null">未开始</span><span v-if="scope.row.meetingState == '已开始'" class="state-green">已开始</span><span v-if="scope.row.meetingState == '已结束'"  class="state-orange">已结束</span></template>
        </el-table-column>
        <el-table-column prop="createTime" label="申请流程时间" header-align="center" align="left" width="170">
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column prop="fundState" label="会议开始时间" header-align="center" align="left" width="150">
          <template slot-scope="scope">{{ scope.row.startTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column prop="fundState" label="会议结束时间" header-align="center" align="left" width="150">
          <template slot-scope="scope">{{ scope.row.endTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
          <template slot-scope="scope">

            <a class="txt-color" @click="toLink(2,scope.row)" v-if="scope.row.isMeetingApply=='Y'">会议管理 | </a>
            <a class="txt-color" @click="toLink(3,scope.row)" v-if="(scope.row.videoUrl !== null) && (scope.row.videoUrl !== '')&&scope.row.isMeetingApply=='Y'">查看视频 | </a>
                        <a class="txt-color" @click="toLink(1,scope.row)">详情</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- 会议管理 -->
    <el-dialog title="会议管理" :visible.sync="visible2" width="40%" center>
      <div class="management">
        <div class="management-list mb30">
          <div class="management-name">会议视频链接：</div>
          <el-input
            class="list-textarea"
            type="textarea"
            :rows="4"
            placeholder="请输入会议视频链接"
            v-model="videoUrl">
          </el-input>
        </div>
        <div class="management-list">
          <div class="management-name">会议可见部门：</div>
          <div><span class="designee mb10" v-show="departmentData !== '' || departmentData !== null" v-for="(item,index) in departmentData" :key="index"
          ><span class="select-name">{{ item.organisationName }}</span>
          <span @click="delDepartmentSingle(index)" class="ml10 cursor-sty font-S19">×</span></span
        > <span class="select-department" @click="visible3 = true">{{departmentData && departmentData.length>0?'修改':'选择部门'}}</span></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible2 = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitVideoUrl()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 选择部门 -->
    <el-dialog title="选择部门" :visible.sync="visible3" width="60%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick1"
              ref="tree"
            >
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个部门</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
              >批量删除</el-button
            >
            <el-table
              :data="departmentList"
              v-loading="tableLoading"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="名称"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
        <!-- <el-button size="medium" type="info" v-else @click="upDateForm1('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffGuid: '',
        startTime: '',
        endTime:'',
        meetingSubject:'',
        meetingStartState:0,
        isPowerShow:0,
        listType:0
      },
      meetingStartState: [
        { value: 0, label: '全部' },
        { value: 1, label: '未开始' },
        { value: 2, label: '已开始' },
        { value: 3, label: '已结束' },
      ],
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
      },
      tenantList: [],
      tenantListDz: [],
      tableData: [],
      sendTime: '',
      right: 'right',
      tableLoading: false,
      fullscreenLoading: false,
      visible2:false,//会议管理弹框
      visible3:false,//选择部门弹框
      meetingGuid:'',
      departmentData:[],
      departmentList: [],
      videoUrl:'',
      area:[],
      delList:[],
      areaData:[],
      filterText:'',
      tenantGuid:'',
    };
  },
  created() {
    // 列表
    this.getData(false);
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffGuid: '',
        startTime: '',
        endTime:'',
        meetingSubject:'',
        meetingStartState:0,
        isPowerShow:0,
        listType:0
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if(self.page.startTime !== ''){
        self.page.startTime = self.page.startTime.substr(0,10) + ' ' + '00:00:00';
        self.page.endTime = self.page.startTime.substr(0,10) + ' ' + '23:59:59';
      }
      // self.page.staffGuid = JSON.parse(localStorage.userInfo).staffGuid;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/flow/data/get-meeting-list`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          if(res.data.data !== null){
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          }else{
            self.tableData = [];
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    toLink(type,row) {
      let self = this;
      if(type == 1){
        self.$router.push({ path: '/meetingDetail', query: { guid: row.guid ,tenantName:row.tenantName,meetingState:(row.meetingState!==null) ? row.meetingState:'未开始',meetingTimeLong:row.meetingTimeLong,isMeetingApply:row.isMeetingApply} });
      }else if(type == 2){
        self.meetingGuid = row.guid;
        if(row.videoUrl !== null && row.organisations !== null){
          self.videoUrl = row.videoUrl;
          self.departmentData = row.organisations;
          self.departmentList = row.organisations;
        }else{
          self.videoUrl = '';
          self.departmentData = [];
        }
        self.visible2 = true;
        self.getOrganisation(row.tenantGuid);
      }else{
        window.open(row.videoUrl)
      }
      
    },
    //获取组织
    getOrganisation(guid) {
      let self = this;
      self.api
      .get(`/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?bizState=Y&tenantGuid=` + guid)
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.areaData = res.data.data;
        } else {
          self.$message.error(res.data.msg);
          self.areaData = [];
          self.tableData = [];
        }
      });
    },
    unique(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    //部门弹框选择
    handleNodeClick1(data) {
      let self = this;
      console.log(data);
      let item = {
        guid: data.guid,
        organisationName: data.organisationName
      };
      self.area.push(JSON.stringify(item));    
      self.area = self.unique(self.area);
      self.departmentList = [];
      self.area.forEach(function (i) {
        self.departmentList.push(JSON.parse(i));
      });
      console.log(self.departmentData);
    },
    //确定选择部门
    departmentSure(){
      this.departmentData = this.departmentList;
      console.log(this.departmentData)
      this.visible3 = false;
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    //删除单个部门
    delDepartmentSingle(index){
      this.departmentData.splice(index,1);
      this.departmentList = this.departmentData;
      this.area.splice(index,1)
      // this.departmentList.splice(index,1)
    },
    
    //提交会议链接
    submitVideoUrl(){
      let self = this;
      if(self.departmentData !== null){
        var departmentData = []
        self.departmentData.forEach(item=>{
          departmentData.push(item.guid)
        })
      }
      let query = {
        guid:self.meetingGuid,
        videoUrl:self.videoUrl,
        organisationGuids:departmentData,
      }
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/flow/data/edit-meeting-org-info`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('提交成功！');
          self.visible2 = false;
          self.getData();
        } else {
          self.$message.error(res.data.msg);
          self.fullscreenLoading = false;
        }
      }).catch(() => {
        self.$message.success('接口异常！');
        self.fullscreenLoading = false;
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script> 
